import language from './language';
// import ResourceTypes from "../components/ResourceTypes";
const { createNoise2D } = require('simplex-noise');
const seedrandom = require('seedrandom');

function generateTile(planet, position, Xfloor, Yfloor, simplex) {
  if (planet.terrains[Yfloor] === undefined) {
    planet.terrains[Yfloor] = [];
  }
  if (planet.terrains[Yfloor][Xfloor] === undefined) {
    planet.terrains[Yfloor][Xfloor] = {};
    // console.log('Tileset does not exist on', Yfloor, Xfloor);
    planet.terrains[Yfloor][Xfloor].terrain = [];
    planet.terrains[Yfloor][Xfloor].waterIntensity = 0;
    planet.terrains[Yfloor][Xfloor].combinedHeight = 0;
    for (let y = 0; y < 9; y++) {
      planet.terrains[Yfloor][Xfloor].terrain[y] = [];
      for (let x = 0; x < 16; x++) {
        let nx = (Xfloor * 16 + x) / planet.size.height - 0.5,
          ny = (Yfloor * 9 + y) / planet.size.width - 0.5,
          noise =
            Math.round(
              (simplex(nx, ny) +
                0.5 * simplex(2 * nx, 2 * ny) +
                0.25 * simplex(4 * nx, 4 * ny) +
                0.125 * simplex(8 * nx, 8 * ny) +
                0.2) *
                100
            ) / 100;
        planet.terrains[Yfloor][Xfloor].terrain[y][x] = noise;
        planet.terrains[Yfloor][Xfloor].combinedHeight += noise;
        if (noise < 0) {
          ++planet.terrains[Yfloor][Xfloor].waterIntensity;
        }
        if (y === 8 && x === 15) {
          planet.terrains[Yfloor][Xfloor].combinedHeight =
            Math.round(planet.terrains[Yfloor][Xfloor].combinedHeight * 100) /
            100;
        }
      }
    }
  } else {
    console.log('Tileset exists on', Yfloor, Xfloor);
  }
}

const generatePlanet = (planet, position) => {
  console.log('Generating planet for', position);
  planet.name = language;
  planet.hue = 0;
  // planet.hue = Math.floor(seedrandom(planet.seed)()*360);
  // planet.availableResources = ResourceTypes;
  let size = Math.round(seedrandom(planet.seed)() * 2) + 10;
  planet.size = {
    width: size * 9,
    height: size * 16,
  };

  let simplex = new createNoise2D(seedrandom(planet.seed)),
    Xalign = position.x % 16,
    Yalign = position.y % 9,
    Xfloor = Math.floor(position.x / 16),
    Yfloor = Math.floor(position.y / 9);

  generateTile(planet, position, Xfloor, Yfloor, simplex);
  if (Xalign > 0 && Yalign > 0) {
    generateTile(planet, position, Xfloor + 1, Yfloor + 1, simplex);
  }
  if (Xalign > 0) {
    generateTile(planet, position, Xfloor + 1, Yfloor, simplex);
  }
  if (Yalign > 0) {
    generateTile(planet, position, Xfloor, Yfloor + 1, simplex);
  }
};

const generateStartLocation = (planet) => {
  let size = Math.round(seedrandom(planet.seed)() * 2) + 10;
  planet.size = {
    width: size * 9,
    height: size * 16,
  };

  let simplex = new createNoise2D(seedrandom(planet.seed));

  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) {
      generateTile(planet, { x: x * 16, y: y * 9 }, x, y, simplex);
    }
  }

  let heightArray = [];
  let minHeight = {
    height: 144,
    coordinates: null,
  };
  for (let y = 0; y < size; y++) {
    heightArray[y] = [];
    for (let x = 0; x < size; x++) {
      heightArray[y][x] = planet.terrains[y][x].combinedHeight;
      if (heightArray[y][x] > 0 && heightArray[y][x] < minHeight.height) {
        minHeight.height = heightArray[y][x];
        minHeight.coordinates = { x: x * 16, y: y * 9 };
      }
    }
  }
  return minHeight;
};

export { generatePlanet, generateStartLocation };
